import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "../../Assets/Styles/RobotTaskSchedule.css";
import RobotTaskFields from "./RobotTaskFields";
import AxiosInstance from "../Axios/AxiosInstance";

const localizer = momentLocalizer(moment);

export const RobotTaskSchedule = () => {
    const [tasks, setTasks] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentTask, setCurrentTask] = useState(null);

    // 📥 Load tasks
    const loadTasks = async () => {
        try {
            const response = await AxiosInstance.get("RobotTaskSchedule/GetTask");
            const data = response.data;

            const formatted = data.map((t) => ({
                ...t,
                start_date: new Date(t.start_date),
                end_date: new Date(t.end_date),
                title: t.task_name,
                boundary_coordinates: t.boundary_coordinates || "[]",
            }));
            setTasks(formatted);
        } catch (err) {
            console.error("❌ Failed to load tasks:", err);
        }
    };

    useEffect(() => {
        loadTasks();
    }, []);

    const handleSelectEvent = (task) => {
        setCurrentTask(task);
        setModalOpen(true);
    };

    const handleSelectSlot = (slot) => {
        setCurrentTask({
            task_name: "",
            task_type: "",
            start_date: slot.start,
            end_date: slot.end,
            status: "Scheduled",
            boundary_coordinates: "[]",
        });
        setModalOpen(true);
    };

    const handleSubmitTask = async (taskData) => {
        try {
           // alert("1");
            const response = await AxiosInstance.post(
                "/api/RobotTaskSchedule/SaveTask",
                taskData
            );
          //  alert("1");
            if (response.status === 200) {
                alert("✅ Task saved successfully");
                setModalOpen(false);
                loadTasks();
            } else {
                alert("❌ Failed to save task");
            }
        } catch (error) {
            console.error("Save Error:", error);
            alert("❌ Error saving task");
        }
    };

    const eventStyleGetter = (event) => {
        let backgroundColor = "#4CAF50";
        if (event.status === "InProgress") backgroundColor = "#2196F3";
        if (event.status === "Done") backgroundColor = "#9E9E9E";
        if (event.status === "Cancelled") backgroundColor = "#F44336";
        return {
            style: {
                backgroundColor,
                borderRadius: "4px",
                color: "white",
                fontSize: "0.75rem",
                padding: "2px 4px",
            },
        };
    };

    const CustomToolbar = ({ label, onNavigate, onView }) => (
        <div className="rbc-toolbar">
            <div className="rbc-btn-group">
                <button onClick={() => onNavigate("PREV")}>Prev</button>
                <button onClick={() => onNavigate("TODAY")}>Today</button>
                <button onClick={() => onNavigate("NEXT")}>Next</button>
            </div>
            <div className="rbc-toolbar-label">{label}</div>
            <div className="rbc-btn-group">
                <button onClick={() => onView("month")}>Month</button>
                <button onClick={() => onView("week")}>Week</button>
                <button onClick={() => onView("day")}>Day</button>
            </div>
        </div>
    );

    return (
        <div style={{ padding: 20 }}>
            <h2 style={{ marginBottom: 10 }}>Robot Task Schedule</h2>

            <Calendar
                localizer={localizer}
                events={tasks}
                startAccessor="start_date"
                endAccessor="end_date"
                selectable
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
                views={["month", "week", "day"]}
                defaultView="month"
                style={{ height: 550 }}
                popup
                components={{ toolbar: CustomToolbar }}
                eventPropGetter={eventStyleGetter}
            />

            {modalOpen && currentTask && (
                <RobotTaskFields
                    task={currentTask}
                    onClose={() => setModalOpen(false)}
                    onSubmit={handleSubmitTask}
                />
            )}
        </div>
    );
};

export default RobotTaskSchedule;
